module.exports = __webpack_public_path__ + "assets/umbraco.0b9f7875.svg";